import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { useTheme } from '@mui/material/styles';
import React from "react";
import { useSelector } from "react-redux";
import { StyledDrawer } from "../../styled/Layout";
import MenuAppBar from "./MenuAppBar";



function ResponsiveDrawer({ open, handleDrawerToggle }) {
  const theme = useTheme();

  const logo = useSelector((state) => state.logo.getLogo);

  return (
    <StyledDrawer.Drawer
      variant="permanent"
      open={open}
    >
      <StyledDrawer.Toolbar>
        <StyledDrawer.Logo src={logo.data} alt="logo" />
        <StyledDrawer.ArrowToolbar
          onClick={handleDrawerToggle}
          size="small"
        >
          {theme.direction === "rtl" ? <ChevronRight /> : <ChevronLeft />}
        </StyledDrawer.ArrowToolbar>
      </StyledDrawer.Toolbar>
      <MenuAppBar />
    </StyledDrawer.Drawer>
  );
}

export default ResponsiveDrawer;
